var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.location.show)?_c('div',[_c('GmapMarker',{ref:_vm.location.id,attrs:{"position":_vm.position,"clickable":true,"icon":_vm.markerIcon},on:{"click":function($event){return _vm.handleClick()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }